// extracted by mini-css-extract-plugin
module.exports = {"FullWidthTeaser":"FullWidthTeaser--NcFUs"};